import React from 'react'
import './Carousel.css'

const Carousel = () => {
    return (
        <div className="carousel">
            <div className="cardEventCarousel">
  
                <div className="card_part card_part-one">
                    <h1>
                        ROBOWARS
                    </h1>
                    <h2>
                        We conducted robowars which was a big hit.Students of different schools and colleges from patna participated.Robowars are probably among the most awaited events because of the thrill and excitement it provides.We have all grown watching transformers and it gives quite a similar feel.Robowars had a history of attracting great audiences from different colleges over the years and it’s prize amount have always been the highest. Yesteryear,I was won by a Team from Nit Silchar.
                    </h2>
                </div>
                

                <div className="card_part card_part-two">
                    <h1>
                        CHAKRAVYUH
                    </h1>
                    <h2>
                        We had a maze solving event which was based on the backdrop of Abhimanyu’s chakravyuh from Mahabharata.The bot was supposed to be abhimanyu and it had to reach to centre of the maze(or chakravyuh) using its weapons i.e, the codes in this case.It attracted a lot of audience especially from the programming background. The fascination factor was also there because of the interesting backdrop .
                    </h2>
                </div>

                
                <div className="card_part card_part-three">
                    <h1>
                        THE LION’S KINGDOM
                    </h1>
                    <h2>
                        In lion’s Kingdom, participants had to traverse their bots through a zig zag path overcoming the obstacles.The path had holes which were meant to be filled using cubes placed along the path.This event saw maximum participation because of its straightforward demands and facile nature.
                    </h2>
                </div>
                
                <div className="card_part card_part-four">
                    <h1>
                        3D printing Workshop
                    </h1>
                    <h2>
                        Robotics club, NIT Patna conducted a two days Workshop on 3D printing. In the workshop basics of 3D designing were discussed. The participants gained a sound knowledge about the parts, principles, and working of 3D printing. They were given access to use the 3D printer of our club to gather some ideas about how to operate it, what are its specific features. It was a great hands-on experience of creating stuff like Robotics arm, gear, etc for all those who participated.
                    </h2>
                </div>

            </div>
        </div>
    )
}

export default Carousel
